import { useMemo, useState } from 'react';

import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

interface DomainsAutoCompleteProps {
  autoCompleteValue?: string;
  setAutoCompleteValue: (value: string) => void;
  size: 'small' | 'medium';
  disabled?: boolean;
  hasError?: boolean;
  newKey?: string;
  domains: string[];
  helperText?: string;
  onSelection?: (value: string) => void;
}

export default function DomainsAutoComplete({
  autoCompleteValue,
  setAutoCompleteValue,
  size,
  disabled,
  hasError,
  domains,
  helperText,
  newKey,
  onSelection,
}: DomainsAutoCompleteProps) {
  const [inputValue, setInputValue] = useState('');

  const key = useMemo(
    () => newKey || new Date().getTime().toString(),
    [newKey]
  );

  return (
    <Autocomplete
      key={key}
      id="domains-autocomplete"
      disabled={disabled}
      componentsProps={{
        paper: {
          sx: {
            minWidth: 400,
          },
        },
      }}
      getOptionLabel={(option) => option}
      options={domains.sort((a, b) => {
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
      })}
      size={size}
      autoComplete
      autoHighlight
      onChange={(_event, newValue, reason) => {
        if (reason === 'clear') {
          setAutoCompleteValue('');
          if (onSelection) {
            onSelection('');
          }
          return;
        }
        let selectedValue = '';
        selectedValue = newValue || '';
        setAutoCompleteValue(selectedValue);
        if (
          selectedValue &&
          (reason === 'selectOption' || reason === 'createOption') &&
          onSelection
        ) {
          onSelection(selectedValue);
        }
      }}
      noOptionsText="No Domains Found"
      renderInput={(params) => (
        <TextField
          {...params}
          label="Search for a domain"
          fullWidth
          error={hasError}
          helperText={helperText}
        />
      )}
      value={autoCompleteValue}
      inputValue={inputValue}
      onInputChange={(_event, newInputValue) => {
        setInputValue(newInputValue);
      }}
    />
  );
}
